import request from '@/utils/request'

// 修改卡主收款付款模式
export function updatePaymentMode(id, params) {
  return request({
    url: `/account/updatePaymentMode/${id}`,
    method: 'post',
    params,
  })
}

// 发送确认帐户手机短信功能是否正常的请求
export function sendCheckAccPhoneSmsRequest(id) {
  return request({
    url: `/account/bank/sendCheckAccPhoneSmsRequest/${id}`,
    method: 'post',
  })
}

// 取得银行卡异常历程
export function errorFeedbackHistory(id, params) {
  return request({
    url: `/account/errorFeedbackHistory/${id}`,
    method: 'get',
    params,
  })
}

// 卡主时效性启用银行卡次数动态设定数据(策略版)
export function customerEnableNumByTactics(id) {
  return request({
    url: `/account/customerEnableNumByTactics/${id}`,
    method: 'get',
  })
}

// 卡主时效性启用银行卡次数动态设定数据
// export function customerEnableCardInfo(id) {
//   return request({
//     url: `/account/customerEnableCardInfo/${id}`,
//     method: 'get',
//   })
// }

// 管理员当日开启几次银行卡
export function getAdminEnableNum(id) {
  return request({
    url: `/account/adminEnableNum/${id}`,
    method: 'get',
  })
}

// 操作员确认银行卡上线
export function updateLoginStatus(id, params) {
  return request({
    url: `/account/operator/updateLoginStatus/${id}`,
    method: 'post',
    params: params,
  })
}

// 管理员禁用银行卡
export function adminDisable(id, data) {
  return request({
    url: `/account/adminDisable/${id}`,
    method: 'post',
    data,
  })
}

// 批量修改协议代理位置
export function batchUpdateProxyPool(data) {
  return request({
    url: '/account/batchUpdateProxyPool',
    method: 'patch',
    data: data,
  })
}

// 取得银行卡资讯
export function getAccountInfo(id) {
  return request({
    url: `/account/${id}`,
    method: 'get',
  })
}

// 取得用户所有银行卡帐户列表
export function userAllAccount(id) {
  return request({
    url: `/account/userAllAccount/${id}`,
    method: 'get',
  })
}

// 无痛转移银行卡扫脸视频
export function copyAccVideo(data) {
  return request({
    url: '/account/copyAccVideo',
    method: 'post',
    data: data,
  })
}

// 更新影像档状态
export function updateFaceVideoStatus(data) {
  return request({
    url: '/account/updateFaceVideoStatus',
    method: 'patch',
    data: data,
  })
}

// 取得银行卡禁用/启用历程
export function bankCardEnableHistory(id, params) {
  return request({
    url: `/account/bankCardEnableHistory/${id}`,
    method: 'get',
    params: params,
  })
}

// 获取帐户影片路径
export function getAccVideo(id) {
  return request({
    url: `/account/getAccVideo/${id}`,
    method: 'get',
  })
}

// 银行卡取消配置设备
export function unassignCloudPhone(id) {
  return request({
    url: `/account/unassignCloudPhone/${id}`,
    method: 'patch',
  })
}

// 银行卡配置设备
export function assignCloudPhone(data) {
  return request({
    url: '/account/assignCloudPhone',
    method: 'patch',
    data: data,
  })
}

// 修改群组级距分组
export function updateBankCardPriorityGroup(id, data) {
  return request({
    url: `account/bank/updateBankCardPriorityGroup/${id}`,
    method: 'put',
    data: data,
  })
}

// 银行卡批量分组修改
export function batchUpdateAmsAccGroupCode(data) {
  return request({
    url: 'account/bank/batchUpdateAmsAccGroupCode',
    method: 'patch',
    data: data,
  })
}

// 新增群组级距分组
export function addBankCardPriorityGroup(data) {
  return request({
    url: 'account/bank/addBankCardPriorityGroup',
    method: 'post',
    data: data,
  })
}

// 群组级距分组列表
export function bankCardPriorityGroup(params) {
  return request({
    url: 'account/bank/listBankCardPriorityGroup',
    method: 'get',
    params: params,
  })
}

// 银行卡级距分组选项列表
export function listAmsBankCardPriorityGroupBySelect(params) {
  return request({
    url: '/account/bank/listAmsBankCardPriorityGroupBySelect',
    method: 'get',
    params: params,
  })
}

// 删除银行卡
export function accountCardDelete(id) {
  return request({
    url: `/account/delete/${id}`,
    method: 'post',
  })
}

// 恢复银行卡
export function accountCardRecover(id) {
  return request({
    url: `/account/recover/${id}`,
    method: 'post',
  })
}

// 各银行出款量和帐户数统计
export function accountStatistics(params) {
  return request({
    url: `/account/accountStatistics`,
    method: 'get',
    params: params,
  })
}

// 银行卡上报
export function errorFeedback(data) {
  return request({
    url: '/account/errorFeedback',
    method: 'post',
    data: data,
  })
}

// 强制重新登录
export function forceLogin(id) {
  return request({
    url: `/account/forceLogin/${id}`,
    method: 'get',
  })
}

// 修改帐户限制
export function updateLimit(id, data) {
  return request({
    url: `/account/updateLimit/${id}`,
    method: 'patch',
    data: data,
  })
}

// 取得操作员被指派的所有银行卡列表
export function listOperableAccounts(id, params) {
  return request({
    url: `/account/listOperableAccounts/${id}`,
    method: 'get',
    params: params,
  })
}

export function updateFaceImgPath(data) {
  return request({
    url: `/account/updateFaceImgPath/${data.id}`,
    method: 'patch',
    data: {
      faceImgPath: data.faceImgPath
    },
  })
}

export function getAccountList(params) {
  if (params && params.minJifenBalance && typeof (params.minJifenBalance) === 'string') { params.minJifenBalance = params.minJifenBalance.replace(',', '') }
  if (params && params.maxJifenBalance && typeof (params.maxJifenBalance) === 'string') { params.maxJifenBalance = params.maxJifenBalance.replace(',', '') }
  if (params && params.minBalance && typeof (params.minBalance) === 'string') { params.minBalance = params.minBalance.replace(',', '') }
  if (params && params.maxBalance && typeof (params.maxBalance) === 'string') { params.maxBalance = params.maxBalance.replace(',', '') }
  return request({
    url: '/account/list',
    method: 'get',
    params: params,
  })
}

// 取得纯手动卡主的银行卡，这接口后端固定按照 createdTime 排序
export function listManualCustomer(params) {
  if (params && params.minJifenBalance && typeof (params.minJifenBalance) === 'string') { params.minJifenBalance = params.minJifenBalance.replace(',', '') }
  if (params && params.maxJifenBalance && typeof (params.maxJifenBalance) === 'string') { params.maxJifenBalance = params.maxJifenBalance.replace(',', '') }
  if (params && params.minBalance && typeof (params.minBalance) === 'string') { params.minBalance = params.minBalance.replace(',', '') }
  if (params && params.maxBalance && typeof (params.maxBalance) === 'string') { params.maxBalance = params.maxBalance.replace(',', '') }
  return request({
    url: '/account/listManualCustomer',
    method: 'get',
    params: params,
  })
}

export function getBankReport() {
  return request({
    url: '/account/report/bank',
    method: 'get',
  })
}

export function accountRecycle(id, data) {
  return request({
    url: `/account/recycle/${id}`,
    method: 'post',
    data: data,
  })
}

export function editStatus(data) {
  return request({
    url: `/account/updateStatus/${data.id}`,
    method: 'patch',
    data: data,
  })
}

export function editLimit(data) {
  return request({
    url: `/account/updateLimit/${data.id}`,
    method: 'post',
    data: data,
  })
}

export function accountTopUp(id, data) {
  return request({
    url: `/account/topUp/${id}`,
    method: 'post',
    data: data,
  })
}

// 获取可操作的帐户列表
export function getListOperableAccounts(params) {
  return request({
    url: '/account/listOperableAccounts',
    method: 'get',
    params: params,
  })
}

// 银行卡派单状态检查
export function getDispatchStatus(id) {
  return request({
    url: `/account/dispatchStatus/${id}`,
    method: 'get',
  })
}

// 清空今日支付跑量
export function clearDayTotalPayJifen(accId) {
  return request({
    url: `/account/clearDayTotalPayJifen/${accId}`,
    method: 'get',
  })
}

// 清空今日提现跑量
export function clearDayTotalWithdrawJifen(accId) {
  return request({
    url: `/account/clearDayTotalWithdrawJifen/${accId}`,
    method: 'get',
  })
}

// 优先提现派单
export function priorityWithdrawDispatch(accId) {
  return request({
    url: `/account/priorityWithdrawDispatch/${accId}`,
    method: 'get',
  })
}

// 数据统计，审核员数据 重產
export function calculateOneDayAuditorPerformance(data) {
  return request({
    url: '/account/calculateOneDayAuditorPerformance',
    method: 'post',
    data: data,
  })
}

// 数据统计，操作员数据 重產
export function calculateOneDayOperatorPerformance(data) {
  return request({
    url: 'account/calculateOneDayOperatorPerformance',
    method: 'post',
    data: data,
  })
}

// 移除帐户影片
export function deleteAccVideo(data) {
  return request({
    url: '/account/deleteAccVideo',
    method: 'delete',
    data: data,
  })
}

// 派单频率单次接单-接下一单
export function triggerGetNewOrder(accId) {
  return request({
    url: `/account/triggerGetNewOrder/${accId}`,
    method: 'patch',
  })
}

// 为手动卡主新增银行帐户
export function addBankAccountForManualCustomer(data) {
  return request({
    url: '/account/bank/addBankAccountForManualCustomer',
    method: 'post',
    data,
  })
}

// 修改銀行帳戶馀额
export function updateBankAccountBalance(id, data) {
  return request({
    url: `/account/bank/updateBankAccountBalance/${id}`,
    method: 'patch',
    data,
  })
}

// DSY-1071 通道代理新建一个新开关,可支持统一调整底下所有卡主卡的收付款限额
export function updateChannelPayAndWithdrawLimit(data) {
  return request({
    url: `/account/updateChannelPayAndWithdrawLimit/${data.userId}`,
    method: 'post',
    data,
  })
}

// 收款检测
export function simulationPay(accId, params) {
  return request({
    url: `/account/simulationPay/${accId}`,
    method: 'get',
    params
  })
}

// 出款检测
export function simulationWithdraw(accId, params) {
  return request({
    url: `/account/simulationWithdraw/${accId}`,
    method: 'get',
    params
  })
}

/* =================== Start Code =================== */
export function getAccountQrcodeList(params) {
  if (params && params.minJifenBalance && typeof (params.minJifenBalance) === 'string') { params.minJifenBalance = params.minJifenBalance.replace(',', '') }
  if (params && params.maxJifenBalance && typeof (params.maxJifenBalance) === 'string') { params.maxJifenBalance = params.maxJifenBalance.replace(',', '') }
  if (params && params.minBalance && typeof (params.minBalance) === 'string') { params.minBalance = params.minBalance.replace(',', '') }
  if (params && params.maxBalance && typeof (params.maxBalance) === 'string') { params.maxBalance = params.maxBalance.replace(',', '') }
  return request({
    url: '/account/qrcode/list',
    method: 'get',
    params: params,
  })
}

export function updateQrcodeStatus(data) {
  return request({
    url: `/account/qrcode/updateStatus/${data.id}`,
    method: 'patch',
    data: data,
  })
}

// 获取上传Acc文件的密文
export function getUploadMediaCiphertext() {
  return request({
    url: '/account/getUploadAccFileCiphertext',
    method: 'get',
  })
}

// 解析二维码内容
export function analyzeQRCode(params) {
  return request({
    url: '/account/qrcode/analyzeQRCode',
    method: 'post',
    params,
  })
}


// 修改帐户限制（二维码）
export function updateQRCodeLimit(id, data) {
  return request({
    url: `/account/qrcode/updateLimit/${id}`,
    method: 'patch',
    data,
  })
}

// 短信对应动作选单
export function bankSmsActionList() {
  return request({
    url: '/account/bank/bankSmsActionList',
    method: 'get',
  })
}

// 短信情境
export function bankSmsSituationList() {
  return request({
    url: '/account/bank/bankSmsSituationList',
    method: 'get',
  })
}

// 获取短信对应动作
export function getBankSmsActionList(params) {
  return request({
    url: '/account/bank/getBankSmsActionList',
    method: 'get',
    params,
  })
}

// 更新银行信息对应动作
export function updateResponseAction(data) {
  return request({
    url: '/account/bank/updateResponseAction',
    method: 'post',
    data,
  })
}

// 变更派单模式
export function changeDispatchMode(id, data) {
  return request({
    url: `/account/changeDispatchMode/${id}`,
    method: 'post',
    data,
  })
}

// 为手动卡主添加二维码帳戶
export function addQRCodeAccountForManualCustomer(data) {
  return request({
    url: '/account/qrcode/addQRCodeAccountForManualCustomer',
    method: 'post',
    data,
  })
}

// 转移用户帐户
export function transferUserAccount(data) {
  return request({
    url: '/account/transferUserAccount',
    method: 'post',
    data,
  })
}

// 转移用户所有帐户
export function transferUserAllAccount(data) {
  return request({
    url: '/account/transferUserAllAccount',
    method: 'post',
    data,
  })
}

// 跨总代转移用户帐户
export function crossFirstAgentTransferUserAccount(data) {
  return request({
    url: '/account/crossFirstAgent/transferUserAccount',
    method: 'post',
    data,
  })
}

// 新增取得用户所有帐户
export function userAllAccTypeAccount(id) {
  return request({
    url: `/account/userAllAccTypeAccount/${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/account.js